import dayjs from 'dayjs';
import { getUserState } from './sg';

const activeStatus = ['in_trial', 'active', 'non_renewing'];

export const hasGrowzSubscription = () => {
  const { store, org } = getUserState();
  return (
    (org.trialEnabled && dayjs(org?.trialEndsOn).format('YYYYMMDD') >= dayjs().format('YYYYMMDD')) ||
    org.agencySubscription === true ||
    activeStatus.includes(store.subscriptionStatus)
  );
};

export const isVendorAccount = () => {
  const { store } = getUserState();
  return store.amazonSPConnected && store.amazonVendorAccount && store.profile.accountInfo.type === 'vendor';
};

export const getFCMTokenName = (userId) => `sg:firebase:${userId}`;

export const hasNotificationToken = (userId) => {
  return !!window.localStorage.getItem(getFCMTokenName(userId));
};

export const hasNotificationPermission = () => {
  return Notification.permission === 'granted';
};

export const hasDeniedNotificationPermission = () => {
  return Notification.permission === 'denied';
};

export const hasFCMToken = (userId) => {
  return window.localStorage.getItem(getFCMTokenName(userId));
};

export const buildStoreEntitlements = () => {
  const { store } = getUserState();
  const { entitlements, strategies, autopilot, dominateKeywords, keywordResearch, rankTracker } = store;
  const usage = {};
  usage.strategies = {
    max: entitlements?.strategies || 0,
    used: strategies?.ACTIVE || 0,
    isActive: Boolean(entitlements?.strategies),
  };
  usage.autopilot = {
    max: entitlements?.autopilot || 0,
    used: autopilot?.ACTIVE || 0,
    isActive: Boolean(entitlements?.autopilot),
  };
  usage.dominateKeywords = {
    max: entitlements?.dominateKeywords || 0,
    used: dominateKeywords?.ACTIVE || 0,
    isActive: Boolean(entitlements?.dominateKeywords),
  };
  usage.keywordResearch = {
    max: entitlements?.keywordResearch || 0,
    used: keywordResearch || 0,
    isActive: Boolean(entitlements?.keywordResearch),
  };
  usage.rankTracker = {
    max: entitlements?.rankTracker || 0,
    used: rankTracker?.keywords?.ACTIVE || 0,
    isActive: Boolean(entitlements?.rankTracker),
  };
  return usage;
};

export const canLaunchMore = (entitlement) => {
  const { store } = getUserState();
  const { entitlements } = store;
  if (!entitlements || !entitlements[entitlement]) return false;

  if (typeof entitlements[entitlement] !== 'number') return true;

  return (
    buildStoreEntitlements()[entitlement].max > 0 &&
    buildStoreEntitlements()[entitlement].max > buildStoreEntitlements()[entitlement].used
  );
};

export const ENTITLEMENTS = {
  STRATEGIES: 'strategies',
  AUTOPILOT: 'autopilot',
  DOMINATE_KEYWORDS: 'dominateKeywords',
  KEYWORD_RESEARCH: 'keywordResearch',
  RANK_TRACKER: 'rankTracker',
};
